export const SIGN_IN_REQUEST = 'auth/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'auth/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'auth/SIGN_IN_FAILURE';

export const SET_AUTH_REQUEST = 'auth/SET_AUTH_REQUEST';
export const SET_AUTH_SUCCESS = 'auth/SET_AUTH_SUCCESS';
export const SET_AUTH_FAILURE = 'auth/SET_AUTH_FAILURE';

export const INIT_ERROR = 'auth/INIT_ERROR';

export const signInRequest = (payload = {}) => ({
  type: SIGN_IN_REQUEST,
  payload,
});
export const signInSuccess = (payload = {}) => ({
  type: SIGN_IN_SUCCESS,
  payload,
});
export const signInFailure = (payload = {}) => ({
  type: SIGN_IN_FAILURE,
  payload,
});

export const setAuthRequest = (payload = {}) => ({
  type: SET_AUTH_REQUEST,
  payload,
});
export const setAuthSuccess = (payload = {}) => ({
  type: SET_AUTH_SUCCESS,
  payload,
});
export const setAuthFailure = (payload = {}) => ({
  type: SET_AUTH_FAILURE,
  payload,
});

export const initError = (payload = {}) => ({
  type: INIT_ERROR,
  payload,
});
